import { PeerTypeEnum } from '@workalizer/shared/enums';
export var diffComparisonType = {
    previousPeriod: 'previousPeriod',
    teamAverage: 'teamAverage'
};
export var diffComparisonValueFormat = {
    durationSeconds: 'durationSeconds',
    durationHours: 'durationHours',
    durationMinutes: 'durationMinutes'
};
/** How `diff` / `diffString` should be read (relative % vs percentage points). */
export var diffDeltaUnit = {
    relativePercent: 'relativePercent',
    percentagePoints: 'percentagePoints'
};
export var DRIVE_DOCUMENTS_ACTIVITY_TYPES = [
    'document',
    'spreadsheet',
    'presentation',
    'other'
];
export var CommunicationNetworkGraphChannelEnum;
(function (CommunicationNetworkGraphChannelEnum) {
    CommunicationNetworkGraphChannelEnum["Email"] = "email";
    CommunicationNetworkGraphChannelEnum["Chat"] = "chat";
    CommunicationNetworkGraphChannelEnum["Meet"] = "meet";
})(CommunicationNetworkGraphChannelEnum || (CommunicationNetworkGraphChannelEnum = {}));
export var COMMUNICATION_NETWORK_GRAPH_CHANNELS = [
    CommunicationNetworkGraphChannelEnum.Email,
    CommunicationNetworkGraphChannelEnum.Chat,
    CommunicationNetworkGraphChannelEnum.Meet
];
export var CommunicationNetworkGraphNodeKindEnum;
(function (CommunicationNetworkGraphNodeKindEnum) {
    CommunicationNetworkGraphNodeKindEnum["Internal"] = "internal";
    CommunicationNetworkGraphNodeKindEnum["InternalMeet"] = "internalMeet";
    CommunicationNetworkGraphNodeKindEnum["CrossTeamSpaceChat"] = "crossTeamSpaceChat";
    CommunicationNetworkGraphNodeKindEnum["ExternalSpaceChat"] = "externalSpaceChat";
    CommunicationNetworkGraphNodeKindEnum["External"] = "external";
    CommunicationNetworkGraphNodeKindEnum["CrossTeamAggregate"] = "crossTeamAggregate";
    CommunicationNetworkGraphNodeKindEnum["Other"] = "other";
    CommunicationNetworkGraphNodeKindEnum["CrossTeam"] = "crossTeam";
})(CommunicationNetworkGraphNodeKindEnum || (CommunicationNetworkGraphNodeKindEnum = {}));
export var CommunicationNetworkGraphScopeEnum;
(function (CommunicationNetworkGraphScopeEnum) {
    CommunicationNetworkGraphScopeEnum["Org"] = "org";
    CommunicationNetworkGraphScopeEnum["Team"] = "team";
    CommunicationNetworkGraphScopeEnum["Employee"] = "employee";
})(CommunicationNetworkGraphScopeEnum || (CommunicationNetworkGraphScopeEnum = {}));
export var CommunicationNetworkGraphInspectorStatVariantEnum;
(function (CommunicationNetworkGraphInspectorStatVariantEnum) {
    CommunicationNetworkGraphInspectorStatVariantEnum["Compact"] = "compact";
    CommunicationNetworkGraphInspectorStatVariantEnum["Extended"] = "extended";
})(CommunicationNetworkGraphInspectorStatVariantEnum || (CommunicationNetworkGraphInspectorStatVariantEnum = {}));
